import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M 3,3 C 2.44772,3 2,3.44772 2,4 v 12 c 0,0.5523 0.44772,1 1,1 h 6.58182 l -4.28917,4.2892 c -0.39053,0.3905 -0.39053,1.0237 0,1.4142 0.39052,0.3905 1.02369,0.3905 1.41421,0 L 11,18.4103 V 22 c 0,0.5523 0.4477,1 1,1 0.5523,0 1,-0.4477 1,-1 v -3.5998 l 4.3032,4.3032 c 0.3905,0.3905 1.0237,0.3905 1.4142,0 0.3905,-0.3906 0.3905,-1.0237 0,-1.4142 L 14.4282,17 H 21 c 0.5523,0 1,-0.4477 1,-1 V 4 C 22,3.44772 21.5523,3 21,3 Z M 20,5 V 6.30768 H 4 V 5 Z M 4,15 V 8.46152 H 20 V 15 Z"
  }));
});
var DescriptivePresentation = AbstractIcon.withComponent(Icon);
DescriptivePresentation.displayName = 'DescriptivePresentation';
export default DescriptivePresentation;